// Login
export const LOGIN = 'api/login';
export const APP_LOGIN = 'api/v2/user/login';
// Refresh token
export const REFRESH_TOKEN = 'login/okta/refresh';
// Password Reset
export const PASSWORD_RESET = 'api/v2/reset-password';
// User Login
export const USER_LOGIN = 'api/v2/user/login';
// SSO Login
export const SSO_LOGIN = 'api/login/sso';
// Logout
export const LOGOUT = `api/v2/user/logout`;
// User Info
export const USER_INFO = 'api/v1/user_info';
// Request Access
export const REQUEST_ACCESS = 'api/v2/request_access';
// Forgot Password
export const FORGOT_PASSWORD = 'api/v2/forgot-password';
// User
export const USER = 'api/v1/user';
// Register Email
export const REGISTER_EMAIL = 'api/v2/register/emails'
// Dealership list
export const DEALERSHIP_LIST = 'api/v2/dealership/search/';
// Salesperson by dealership
export const SALESPERSON_LIST = 'api/v2/user/search-by-dealership/';
// Serial Number API
export const SERIAL_NUMBER = 'api/v2/equipment';
// Enrolled unit
export const ENROLLED_UNIT = 'api/v1/espp/enrolled_units/'
export const ENROLLMENT_FILES = (id: number) => `api/v1/espp/enrollment/${id}/files`;
export const ENROLLMENT_FILE = (id: number, fileId: number) => `api/v1/espp/enrolled_units/${id}/files/${fileId}`;
export const TRAINING = 'api/v2/training-videos';
// Assets for dynamic stylesheet
export const ASSETS = 'api/v2/assets';
// Purchasing dealers (with view level)
export const PURCHASING_DEALERS = 'api/v2/corporation-entities';
// Update User Profile
export const PROFILE_UPDATE = 'api/v1/user/profile-update';
// Quote list
export const QUOTE_LIST = 'api/v1/espp/quotes';
// Duplicate Quote
export const DUPLICATE_QUOTE = (id: number) => `api/v2/quotes/${id}/duplicate`;
// Feature Flags
export const FEATURE_FLAGS = 'api/v1/features';
// Generic file upload/delete (Claims + Enrollments new flow)
export const ESPP_FILES = 'api/v1/espp/files';
export const ESPP_FILE = (fileId: number) => `api/v1/espp/files/${fileId}`;
export const ESPP_FILE_SUBMIT = (fileableType: string, fileableId: number) => `api/v1/espp/${fileableType}/${fileableId}/submit`;
export const ESPP_QUOTE_APPLICATION_FILE = (quoteId: number, fileId: number) => `api/v1/espp/quote_application/${quoteId}/files/${fileId}`;
// Coverage List (Multi term quoting ON)
export const coverageList = (quoteId: number) => `api/v2/quotes/${quoteId}/list-coverages`
